<script setup lang="ts">
import { LucideCookie } from "lucide-vue-next";
import { defineSeo } from "~/lib/utils/seo";

defineSeo({
  title: "Informativa in merito all’utilizzo dei cookies",
});
</script>

<template>
  <FrontBreadcrumHero :search="false" :breadcrumbs="[{ title: 'Informativa in merito all’utilizzo dei cookies' }]"></FrontBreadcrumHero>
  <div class="main-content">
    <div class="lg:grid grid-cols-8 gap-10 xl:gap-20">
      <div class="col-start-2 col-span-6 mb-16 lg:mb-0">
        <h1 class="text-4xl font-extrabold mt-5">Informativa in merito all’utilizzo dei cookies</h1>

        <div class="mb-8">
          <div class="mt-5">
            <div class="prose prose-a:text-primary max-w-full">
              <h2>Cookies tecnici</h2>
              <p>
                Il Sito utilizza prevalentemente cookies tecnici, relativi ad attività strettamente necessarie al funzionamento del Sito stesso e all’erogazione del servizio. Utilizziamo cookie sia di
                sessione che di durata.
              </p>
              <p>Tutti i cookie tecnici non richiedono consenso, perciò vengono installati automaticamente a seguito dell’accesso al Sito, previo avviso informativo.</p>
              <p>
                Non viene fatto uso di cookies per la trasmissione di informazioni di carattere personale, né vengono utilizzati c.d. cookies persistenti di alcun tipo, ovvero sistemi per il
                tracciamento degli utenti.
              </p>
              <p>
                L'uso di c.d. cookies di sessione (che non vengono memorizzati in modo persistente sul computer dell'utente e svaniscono con la chiusura del browser) è strettamente limitato alla
                trasmissione di identificativi di sessione (costituiti da numeri casuali generati dal server) necessari per consentire l'esplorazione sicura ed efficiente del sito.
              </p>
              <p>
                I c.d. cookies di sessione utilizzati in questo sito evitano il ricorso ad altre tecniche informatiche potenzialmente pregiudizievoli per la riservatezza della navigazione degli utenti
                e non consentono l'acquisizione di dati personali identificativi dell'utente.
              </p>
              <h2>Cookies tecnici di terze parti</h2>
              <p>
                Il Sito utilizza cookie tecnici di terze parti (Google Analytics), anonimizzati e utilizzati a soli fini statistici, in conformità con il GDPR (Reg. UE 2016/679), all'art. 122 del
                D.Lgs. 196/2003 e alle Linee Guida Cookie e altri strumenti di tracciamento del 10 giugno 2021.
              </p>
              <h2>Cookies di profilazione</h2>
              <p>
                Utilizziamo cookie di prima parte per personalizzare la tua esperienza sul nostro sito. Raccogliamo informazioni sui contenuti che visualizzi e sulle tue interazioni con il sito al
                fine di suggerirti contenuti che potrebbero interessarti, anche per finalità di marketing personalizzato. Per poter utilizzare tali tecnologie, abbiamo bisogno del tuo consenso libero
                e informato. Senza il consenso, alcune funzionalità del sito, come la sezione “Suggeriti per te” potrebbero non essere disponibili, o proporre contenuti casuali.
              </p>
              <p>
                È possibile in ogni momento revocare il consenso fornito per l’istallazione dei cookies di profilazione utilizzando l’apposita funzione disponibile in basso a destra in ogni pagina del
                sito, contraddistinta con il seguente simbolo:
              </p>
              <Button variant="outline" size="icon" class="rounded-full shadow-lg size-12">
                <LucideCookie class="text-muted-foreground size-7" />
                <span class="sr-only">Gestisci il consenso ai cookie</span>
              </Button>
              <p>La revoca del consenso comporterà la cancellazione, da parte nostra, di tutti i dati personali relativi ai cookies di profilazione.</p>
              <h2>Informativa privacy completa</h2>
              <p>L’informativa privacy completa è <NuxtLink href="/privacy">disponibile a questo indirizzo</NuxtLink>.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
